import { InjectionToken } from '@angular/core';

import { ModalContent } from './modal.service';

export const MODAL_CONTENT_DATA = new InjectionToken<ModalContent>('MODAL_CONTENT_DATA');
